export default "__VITE_ASSET__CubaK99T__"